import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppStore from '../../stores/AppStore';
import Snackbar from 'material-ui/Snackbar';

class SuccessSnackbar extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            open: false
        };
    }

    componentDidMount() {
        this.onSuccessMessage = this.onSuccessMessage.bind(this);
        this.closeSnackbar = this.closeSnackbar.bind(this);
        this.successListener = AppStore.addSuccessListener(this.onSuccessMessage);
    }

    componentWillUnmount() {
        this.successListener.remove();
    }

    render() {
        if (this.state.duration === 0) { return null; } // guard

        return (
            <Snackbar
                open={this.state.open}
                message={this.props.message}
                action="OK"
                autoHideDuration={this.props.duration}
                onRequestClose={this.closeSnackbar}
            />
        );
    }


    onSuccessMessage() {
        this.setState({open: true});
    }

    closeSnackbar() {
        this.setState({open: false});
    }
}

SuccessSnackbar.propTypes = {
    message: PropTypes.string,
    duration: PropTypes.number,
};

SuccessSnackbar.defaultProps = {
    message: 'Saved',
    duration: 1500
};

export default SuccessSnackbar;
